module.exports = __webpack_public_path__ + "static/media/loading.fa4cf14d.svg";